{
  "tabs": {
    "chat": "Söhbət",
    "reminders": "Xatırlatmalar",
    "calendar": "Təqvim",
    "settings": "Ayarlar"
  },
  "common": {
    "cancel": "Ləğv et",
    "save": "Yadda saxla",
    "confirm": "Təsdiqlə",
    "delete": "Sil",
    "back": "Geri",
    "close": "Bağla",
    "edit": "Redaktə et",
    "search": "Axtar",
    "all": "Hamısı",
    "loading": "Yüklənir...",
    "error": "Xəta baş verdi",
    "notFound": "Tapılmadı",
    "tryAgain": "Zəhmət olmasa yenidən cəhd edin",
    "retry": "Təkrar cəhd",
    "undo": "Geri al",
    "pullToRefresh": "Yeniləmək üçün çək",
    "justNow": "indi"
  },
  "auth": {
    "welcome": "FishMemory-yə xoş gəlmisiniz",
    "tagline": "WhatsApp xatırlatma köməkçiniz, indi cibinizdə.",
    "subtitle": "WhatsApp xatırlatma köməkçiniz, indi cibinizdə.",
    "phoneLabel": "WhatsApp nömrəniz",
    "phoneHint": "Təsdiq kodunu WhatsApp vasitəsilə göndərəcəyik",
    "invalidPhone": "Zəhmət olmasa düzgün telefon nömrəsi daxil edin",
    "continue": "Davam et",
    "enterPhone": "WhatsApp nömrənizi daxil edin",
    "phonePlaceholder": "Telefon nömrəsi",
    "sendCode": "Kod göndər",
    "verifyTitle": "Nömrənizi təsdiqləyin",
    "otpSentTo": "{{phone}} nömrəsinə WhatsApp vasitəsilə 6 rəqəmli kod göndərildi",
    "enterFullCode": "Zəhmət olmasa bütün 6 rəqəmi daxil edin",
    "invalidOtp": "Yanlış kod. Zəhmət olmasa yenidən cəhd edin.",
    "otpFailed": "Kod göndərmək alınmadı. Yenidən cəhd edin.",
    "otpResent": "Kod yenidən göndərildi",
    "resendIn": "{{seconds}} saniyədən sonra yenidən göndər",
    "resendCode": "Kodu yenidən göndər",
    "enterOtp": "WhatsApp-a göndərilən kodu daxil edin",
    "verify": "Təsdiqlə",
    "resend": "Kodu yenidən göndər",
    "wrongNumber": "Yanlış nömrə?",
    "backToPhone": "Nömrəyə geri dön",
    "editPhone": "Telefon nömrəsini redaktə et",
    "error": "Xəta",
    "setupTitle": "Quraşdırmanı başlayaq",
    "setupSubtitle": "Bunları istənilən vaxt Ayarlardan dəyişə bilərsiniz",
    "namePlaceholder": "Adınız",
    "letsGo": "Quraşdırmanı bitir",
    "skipForNow": "İndi keç"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Mesaj yazın...",
    "inputPlaceholder": "Mesaj yazın...",
    "typing": "FishMemory yazır...",
    "online": "Onlayn",
    "connecting": "Qoşulur...",
    "reconnecting": "Yenidən qoşulur...",
    "offline": "Oflayn",
    "empty": "Söhbətə başla",
    "emptyHint": "Xatırlatmalar yaradın, cədvəlinizə baxın və ya kömək istəyin.",
    "emptyAction": "Nümunə xatırlatma göndər",
    "actions": "Söhbət əməliyyatları",
    "keep": "Mesajları saxla",
    "clearTitle": "Söhbəti təmizlə",
    "clearConfirm": "Bu cihazdakı bütün mesajları silmək istəyirsiniz? Bu əməliyyat geri alınmaz.",
    "clear": "Söhbəti təmizlə",
    "optionSelected": "Seçildi: {{label}}",
    "sendingSelection": "Göndərilir...",
    "connectionLost": "Yenidən qoşulur..."
  },
  "reminders": {
    "title": "Xatırlatmalarım",
    "active": "Aktiv",
    "today": "Bu gün",
    "thisWeek": "Bu həftə",
    "history": "Tarixçə",
    "items": "elementlər",
    "emptyTitle": "Hələ xatırlatma yoxdur",
    "emptySubtitle": "Söhbətdən yaradın, burada görünəcək.",
    "emptyAction": "Söhbəti aç",
    "filterActive": "Aktiv",
    "filterToday": "Bu gün",
    "filterWeek": "Bu həftə",
    "filterHistory": "Tarixçə",
    "emptyState": "Hələ xatırlatma yoxdur. Söhbətə başlayın!",
    "swipeDone": "Tamamlandı",
    "swipeSnooze": "Gecikdir",
    "swipeDelete": "Sil",
    "search": "Xatırlatmalarda axtar...",
    "upcoming": "Gələnlər",
    "completed": "Tamamlananlar",
    "overdue": "Gecikmiş",
    "tomorrow": "Sabah",
    "synced": "Sinxronlaşdırıldı {{value}}",
    "swipeHint": "Daha çox əməliyyat üçün xatırlatmanı sürüşdürün",
    "noResults": "Axtarışınıza uyğun xatırlatma yoxdur",
    "noResultsHint": "Başqa açar söz sınayın və ya axtarışı təmizləyin",
    "deleteAllFailed": "Bütün xatırlatmaları silmək alınmadı"
  },
  "calendar": {
    "title": "Təqvim",
    "today": "Bu gün",
    "tomorrow": "Sabah",
    "completed": "tamamlandı",
    "noEvents": "Heç bir plan yoxdur",
    "noEventsSubtitle": "Xatırlatmaları və təqvim hadisələrini görmək üçün tarix seçin.",
    "googleEvent": "Google Təqvimi",
    "legendActive": "Aktiv",
    "legendRecurring": "Təkrarlanan",
    "legendDone": "Tamamlandı",
    "legendGoogle": "Google",
    "previousMonth": "Öncəki ay",
    "nextMonth": "Növbəti ay",
    "previousYear": "Öncəki il",
    "nextYear": "Növbəti il",
    "goToToday": "Bu günə get",
    "all": "Hamısı",
    "active": "Aktiv",
    "done": "Tamamlandı",
    "paused": "Dayandırıldı"
  },
  "settings": {
    "title": "Ayarlar",
    "profile": "Profil",
    "name": "Göstərilən ad",
    "enterName": "Adınızı daxil edin",
    "language": "Dil",
    "uiLanguage": "Tətbiq dili",
    "uiLanguageHelp": "Bu cihazda tətbiqin interfeys dilini, təqvim etiketlərini və yerləşmə istiqamətini dəyişir.",
    "serverLanguage": "Söhbət dili",
    "serverLanguageHelp": "Hesabınız üçün server cavablarında və xatırlatma mesajlarında istifadə olunan dili dəyişir.",
    "timezone": "Zaman zonası",
    "currentTimezone": "Cari zaman zonası",
    "timezoneHelp": "Bütün xatırlatma vaxtları bu zaman zonasına görə göstərilir.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Zaman zonasını yadda saxla",
    "timezoneSaved": "Zaman zonası yeniləndi",
    "detect": "Aşkarlamaq",
    "detectFailed": "Zaman zonası aşkarlanmadı",
    "autoDetect": "GPS-dən avtomatik aşkarlama",
    "notifications": "Bildirişlər",
    "notificationsHelp": "Təqib xatırlatmaları xatırlatma çatdırıldıqdan sonra təkrar xəbərdarlıqları idarə edir. Cihaz səviyyəsində bildiriş icazələri telefon ayarlarınızda idarə olunur.",
    "pushEnabled": "Push bildirişləri",
    "autoDoneOnFire": "Fəallaşanda avtomatik tamamla",
    "autoDoneOnFireDesc": "Söndürüldükdə, xatırlatmalar tamamlanana qədər aktiv qalır.",
    "googleCalendar": "Google Təqvimi",
    "google": "Google Təqvimi",
    "googleConnected": "Qoşulub",
    "googleDisconnected": "Qoşulmayıb",
    "googleConnectedHelp": "Yeni xatırlatmalar avtomatik olaraq təqviminizə sinxronlaşdırıla bilər.",
    "googleDisconnectedHelp": "Xatırlatmalar və hadisələrin uyğunluğunu saxlamaq üçün Google Təqvimini qoşun.",
    "googleConnectFailed": "Google Təqvimini qoşmaq alınmadı",
    "connected": "Qoşulub",
    "disconnected": "Qoşulmayıb",
    "connect": "Qoşul",
    "disconnect": "Qoşulmanı kəs",
    "autoSync": "Yeni xatırlatmaları avtomatik sinxronizasiya et",
    "autosync": "Yeni xatırlatmaları avtomatik sinxronizasiya et",
    "subscription": "Abunəlik",
    "trialUsed": "Sınaq: {{used}}/{{total}} istifadə edildi",
    "trialStatus": "Sınaq mövcuddur",
    "activeStatus": "Aktiv abunəlik",
    "expiredStatus": "Abunəlik müddəti bitib",
    "unsubscribedStatus": "Abunə deyil",
    "about": "Haqqında",
    "version": "Versiya",
    "logout": "Çıxış",
    "logoutTitle": "Çıxış",
    "logoutConfirm": "Çıxmaq istədiyinizə əminsiniz?",
    "noName": "Ad təyin edilməyib",
    "serverConnection": "Server bağlantısı",
    "serverUrl": "Server URL",
    "serverEdit": "Redaktə et",
    "saveReconnect": "Yadda saxla və yenidən qoşul",
    "resetDefault": "Standarta qaytar",
    "invalidServerUrlTitle": "Yanlış server URL",
    "invalidServerUrlMessage": "Məsələn https://example.com kimi düzgün http və ya https server URL daxil edin",
    "uiLanguageChangeFailed": "Tətbiq dilini dəyişmək alınmadı. Zəhmət olmasa yenidən cəhd edin.",
    "serverLanguageChangeFailed": "Söhbət dilini dəyişmək alınmadı. Zəhmət olmasa yenidən cəhd edin.",
    "timezoneChangeFailed": "Zaman zonasını dəyişmək alınmadı. Zəhmət olmasa yenidən cəhd edin.",
    "autoSyncChangeFailed": "Avtomatik sinxronizasiyanı yeniləmək alınmadı. Zəhmət olmasa yenidən cəhd edin.",
    "nameChangeFailed": "Göstərilən adı yeniləmək alınmadı. Zəhmət olmasa yenidən cəhd edin.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Xatırlatma detalları",
    "editTime": "Vaxtı redaktə et",
    "rename": "Adını dəyiş",
    "snooze": "Gecikdir",
    "snooze15": "15 dəqiqə gecikdir",
    "pause": "Dayandır",
    "pauseReminder": "Xatırlatmanı dayandır",
    "resume": "Davam et",
    "resumeReminder": "Xatırlatmanı davam et",
    "skip": "Növbətiyi keç",
    "skipOccurrence": "Bu təkrarı keç",
    "syncGoogle": "Google ilə sinxronizasiya et",
    "delete": "Sil",
    "deleteTitle": "Xatırlatmanı sil",
    "deleteConfirm": "Bu xatırlatma daimi olaraq silinəcək.",
    "deleteRecurringTitle": "Təkrarlanan xatırlatmanı sil",
    "deleteRecurringMessage": "Bu təkrarı keçmək istəyirsiniz, yoxsa bütün seriyanı silmək?",
    "deleteThisOccurrence": "Bu təkrarı keç",
    "deleteEntireSeries": "Bütün seriyanı sil",
    "done": "Tamamlandı",
    "markDone": "Tamamlandı kimi işarələ",
    "undo": "Bərpa et",
    "undoPrompt": "Yenidən aktiv olmalıdır? İndi bərpa et.",
    "recurring": "Təkrarlanan",
    "nextRun": "Növbəti iş",
    "oneTime": "Bir dəfəlik",
    "pending": "Gözləyir",
    "sent": "Göndərildi",
    "paused": "Dayandırıldı",
    "active": "Aktiv",
    "snoozed": "Gecikdirildi",
    "localTime": "Yerel vaxtda göstərilir",
    "recurrence": "Təkrar",
    "created": "Yaradıldı",
    "tags": "Etiketlər",
    "fireCount": "Fəallaşma sayı",
    "actions": "Əməliyyatlar",
    "none": "Yoxdur",
    "snoozeFailed": "Xatırlatmanı gecikdirmək alınmadı",
    "pauseFailed": "Xatırlatmanı dayandırmaq alınmadı",
    "resumeFailed": "Xatırlatmanı davam etdirmək alınmadı",
    "skipFailed": "Xatırlatmanı keçmək alınmadı",
    "doneFailed": "Xatırlatmanı tamamlandı kimi işarələmək alınmadı",
    "undoFailed": "Xatırlatma vəziyyətini bərpa etmək alınmadı",
    "deleteFailed": "Xatırlatmanı silmək alınmadı",
    "rescheduleTitle": "Yenidən planlaşdırılsın?",
    "rescheduleMsg": "Bu xatırlatma gecikib. Yenidən planlaşdırmaq istəyirsiniz?",
    "reschedule15": "15 dəqiqədən sonra",
    "reschedule60": "1 saatdan sonra",
    "keepOverdue": "Elə saxla"
  },
  "onboarding": {
    "slide1Title": "FishMemory-yə xoş gəlmisiniz",
    "slide1Sub": "Şəxsi xatırlatma köməkçiniz — WhatsApp tərəfindən dəstəklənir və cibiniz üçün hazırlanıb.",
    "slide2Title": "Sadəcə Təbii Söhbət edin",
    "slide2Sub": "Xatırlatmaları düşündüyünüz kimi yazın: “Sabah saat 3-də anama zəng etməyi xatırlat” — qalanını biz həll edirik.",
    "slide3Title": "Heç Nəyi Qaçırmayın",
    "slide3Sub": "Vaxtında bildirişlər alın, etiketlərlə təşkil edin və vacib olan hər şeyə nəzarət edin.",
    "getStarted": "Başla",
    "next": "Növbəti",
    "firstReminderTitle": "İlk xatırlatmanızı yaradın!",
    "firstReminderHint": "Belə bir şey yazmağa çalışın:",
    "firstReminderExample": "Sabah saat 9-da su içməyi xatırlat",
    "gotIt": "Başa düşdüm!",
    "notifRationaleTitle": "Vaxtında qalın",
    "notifRationaleBody": "FishMemory vaxtında xatırlatmaq üçün bildirişlərə ehtiyac duyur. Yalnız yaratdığınız xatırlatmalar üçün xəbərdarlıqlar alacaqsınız.",
    "notifRationaleAllow": "Bildirişləri aktiv et",
    "notifRationaleLater": "Bəlkə sonra",
    "swipeHint": "Tez əməliyyatlar üçün sağa sürüşdürün →",
    "calendarDragHint": "Genişləndirmək üçün sürüşdürün ↕"
  }
}
